

import React, { useState, useEffect } from "react";
import { UserTransactionsGet } from "../../Api/CoreApi";
import { Link, useNavigate } from "react-router-dom";
import { SwapOutlined } from "@ant-design/icons"; // add this along with others

import { Button, Table } from "antd";
import {
  DashboardOutlined,
  UserOutlined,
  ReloadOutlined,
  TransactionOutlined,
  LogoutOutlined,
  DollarOutlined,
} from "@ant-design/icons";

function User_Transaction_User() {
  const navigate = useNavigate();

  const id = localStorage.getItem("user_id");
  const [data, setData] = useState([]);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false); // For mobile sidebar
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const user_role = localStorage.getItem('role')

  const permission = () => {
    if (user_role === null || user_role != 'user') {
      navigate('/')
    }
  }

  const getTransactions = async () => {
    try {
      const response = await UserTransactionsGet();
      const filteredTransactions = response.filter(
        (i) => String(i.user_id) === String(id)
      );
      setData(filteredTransactions);
    } catch (error) {
      console.error("Failed to fetch transactions:", error);
    }
  };

  useEffect(() => {
    permission()
    getTransactions();
  }, []);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    if (window.innerWidth <= 768) setSidebarOpen(false);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const log_out = () => {
    localStorage.clear()

    // localStorage.removeItem("user_id");
    navigate("/User_Login");
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const columns = [
    // { title: 'ID', dataIndex: 'id', key: 'id' },
    // { title: 'User ID', dataIndex: 'user_id', key: 'user_id' },
    {
      title: "ID",
      key: "id",
      render: (text, record, index) => index + 1,
    },
    { title: "Amount", dataIndex: "amount", key: "amount" },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      sorter: (a, b) => new Date(a.date) - new Date(b.date),
      render: (text) => {
        if (!text) return 'N/A';
        const date = new Date(text);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      }
    },

    { title: "Type", dataIndex: "type", key: "type" },
    { title: "Status", dataIndex: "status", key: "status" },
  ];

  const containerStyle = {
    padding: "70px 20px",
    marginLeft: isMobile ? "0px" : "200px",
    overflowX: "auto",
    transition: "all 0.3s ease",
    backgroundColor: "#f9f9f9",
    minHeight: "100vh",
  };

  return (
    <div>
      {/* Top Navbar */}
      <div className="app-header">
        <Link to='/' className="header-logo-link">
          <p className="header-logo-text">Rishtey</p>
        </Link>
        <div className="header-right-content">
          <div className="header-nav-wrapper">
            {id ? (
              <Link to='/User_Panel' className="header-nav-link profile-link">
                <p>Profile</p>
              </Link>
            ) : (
              <div className="header-auth-links">
                <Link to='/User_Reg/885695' className="header-nav-link">
                  <p>Sign Up</p>
                </Link>
                <Link to='/User_Login' className="header-nav-link">
                  <p>Login</p>
                </Link>
              </div>
            )}
          </div>
          <Button className="sidebar-toggle-btn" onClick={toggleSidebar}>☰</Button>
        </div>
      </div>

      <div className={`app-sidebar ${isSidebarOpen ? 'open' : ''}`}>
        <Link to='/User_Panel'><Button className="sidebar-btn ">Dashboard</Button></Link>
        <Link to='/User_Recharge'><Button className="sidebar-btn">Recharge</Button></Link>
        <Link to='/User_Transaction_User'><Button className="sidebar-btn active">Transaction</Button></Link>
        <Link to='/User_Added_User'><Button className="sidebar-btn">Share & Earn</Button></Link>
        {/* <Link to='/User_Bank_Details'><Button className="sidebar-btn">User Bank</Button></Link> */}
        {/* <Link to='/User_Withdrawal_User'><Button className="sidebar-btn">Withdrawal</Button></Link> */}
        {/* <Link to='/Post_Commission'><Button className="sidebar-btn">Commissions</Button></Link> */}
        <Button className="sidebar-btn" onClick={log_out}>Log Out</Button>
      </div>


      {/* Main Content */}
      {/* <br /><br /> */}
      <div style={containerStyle}>
        <Table
          columns={columns}
          dataSource={data}
          rowKey="id"
          bordered
          size="middle"
          scroll={{ x: "max-content" }}
          pagination={{ pageSize: 10 }}
        />
      </div>
    </div>
  );
}

export default User_Transaction_User;
